module.exports = __webpack_public_path__ + "static/media/5_12.a7aa1e47.png";